import TextField from '@mui/material/TextField'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'

import {datePickerInputFormat, onChangeHandler} from '../func/datePickerInputFormat'

export default function ChargeDatePicker(props: any) {
  const {state, setState, programName, officeValue} = props

  const today = dayjs().add(9, 'hour')
  const minDate = today.subtract(3, 'month').startOf('month')
  const maxDate = today.add(3, 'month').endOf('month')

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['year', 'month']}
        openTo='month'
        label='납기일자 선택'
        inputFormat={datePickerInputFormat(programName, officeValue)}
        value={state}
        minDate={minDate}
        maxDate={maxDate}
        onChange={(newValue) => setState(onChangeHandler(newValue, programName, officeValue))}
        renderInput={(params) => (
          <TextField
            {...params}
            size='small'
            className='bg-white rounded-md py-6C'
            sx={{
              width: '250px',
              '& .MuiInputBase-root': {
                fontSize: '18px',
                fontWeight: '500',
                padding: '3px 12px 3px 0px',
                fontFamily: 'Noto Sans KR, sans-serif',
              },
              '& .MuiInputLabel-root': {
                fontSize: '18px',
                fontFamily: 'Noto Sans KR, sans-serif',
              },
            }}
          />
        )}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [60, 10],
              },
            },
          ],
          sx: {
            '& .MuiPickersMonth-root': {
              fontFamily: 'Noto Sans KR, sans-serif',
            },
            '& .MuiPaper-root': {
              borderRadius: '10px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              backgroundColor: '#f9fafb',
            },
            '& .MuiPickersCalendarHeader-label': {
              fontFamily: 'Noto Sans KR, sans-serif',
              fontSize: '18px',
              fontWeight: '600',
              '&::after': {
                content: "'년 '",
              },
            },
            '& .MuiPickersMonth-monthButton': {
              fontSize: '16px',
              fontWeight: '500',
              color: '#1f2937',
              '&:hover': {
                backgroundColor: '#e5e7eb',
              },
            },
            '& .MuiTypography-root': {
              fontFamily: 'Noto Sans KR, sans-serif',
              fontSize: '16px',
              fontWeight: '500',
            },
            '& .Mui-selected': {
              fontFamily: 'Noto Sans KR, sans-serif !important',
              backgroundColor: '#273746 !important',
              color: '#ffffff !important',
              fontWeight: '700',
            },
          },
        }}
      />
    </LocalizationProvider>
  )
}
